import React from "react";
import { formatCompact } from "./utils";

const HorizontalBarChart = ({ data, maxValue, showValues = true }) => (
  <div className="space-y-3">
    {data.map((item, idx) => {
      const percentage = maxValue > 0 ? (item.value / maxValue) * 100 : 0;
      return (
        <div key={idx}>
          <div className="flex items-center justify-between mb-1">
            <div className="flex items-center gap-2 min-w-0 flex-1">
              {item.icon && <div className="flex-shrink-0">{item.icon}</div>}
              <span className="text-sm text-theme-text truncate">{item.label}</span>
            </div>
            {showValues && (
              <span className="text-sm font-semibold text-theme-text ml-2">
                {formatCompact(item.value)}
              </span>
            )}
          </div>
          <div className="w-full bg-theme-main rounded-full h-2.5">
            <div
              className="h-2.5 rounded-full transition-all duration-500"
              style={{ width: `${Math.max(percentage, 2)}%`, backgroundColor: item.color || 'var(--color-theme-primary)' }}
            />
          </div>
        </div>
      );
    })}
  </div>
);

export default HorizontalBarChart;
